// removed by extract-text-webpack-plugin
module.exports = {"headerColumn":"mantenedorLocal__headerColumn___AXoRl","evenRow":"mantenedorLocal__evenRow___2MMEI","oddRow":"mantenedorLocal__oddRow___3UbTL","tablaMantenedorLocales":"mantenedorLocal__tablaMantenedorLocales___1bQz3"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/mantenedorLocales2/mantenedorLocal.css
// module id = 957
// module chunks = 0